import React from 'react';
import PropTypes from 'prop-types';
import Plus from '@tradera/blueprint/theme/icons2/plus.svg?jsx';
import { Button } from 'tradera-components/atoms/button/button';

const AttributeButton = ({ className, text, selected, onClick, hoverIcon }) => {
    return (
        <Button
            type="button"
            theme="dark"
            outline={!selected}
            size="xs"
            iconHidden={hoverIcon}
            className={`mb-1 mr-1 ${className}`}
            nowrap
            title={text}
            onClick={onClick}>
            {hoverIcon && <Plus className="icon mr-1" />}
            <span className="btn-inner">{text}</span>
        </Button>
    );
};

AttributeButton.propTypes = {
    className: PropTypes.string,
    text: PropTypes.node.isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    hoverIcon: PropTypes.bool
};

AttributeButton.defaultProps = {
    className: '',
    text: PropTypes.string,
    selected: false,
    onClick: undefined,
    hoverIcon: true
};

export default AttributeButton;
